module.exports = __webpack_public_path__ + "static/media/087-aland-islands.ee854bf4.svg";